export const selectSurveyParticipations = (store) => store.surveys.participationsList;

export const selectSurveysError = (store) => store.surveys.error;
